import { getBusinessRules } from '@ngb-frontend/shared/rules'

import { getDateFnsLocale } from './locale'

import type { QueryCountryCode } from '@ngb-frontend/shared/types'

/** Locale settings for a country (from the country registry) + its date-fns locale */
export const getCountryL10nConfig = (country?: QueryCountryCode) => {
  const conf = getBusinessRules(country).locale
  return {
    ...conf,
    formatLocale: getDateFnsLocale(conf.country),
  }
}
